module.exports = __webpack_public_path__ + "static/media/heart-with-social-media-logo-of-youtube-svgrepo-com.1a540a79.svg";